import { render, staticRenderFns } from "./VatCalibrationScatter.vue?vue&type=template&id=3c1be877&"
import script from "./VatCalibrationScatter.vue?vue&type=script&lang=ts&"
export * from "./VatCalibrationScatter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports